import { LIST_MEMBERSHIP, USER_LIST_MEMBERSHIP } from 'utils/fieldConstants';
import { isEmptyString } from 'utils/stringHelpers';
import { useConditionState } from '../useConditionState';

export const useDisableListsQuery = () => {
  const [{ field }] = useConditionState();
  return isEmptyString(field) || (LIST_MEMBERSHIP !== field && USER_LIST_MEMBERSHIP !== field);
};
